import { gql } from "apollo-angular";

export const ADJUST_ITEM_QUANTITY = gql`
    mutation AdjustItemQuantity($id: ID!, $qty: Int!) {
        adjustOrderLineQuantity(orderLineId: $id, quantity: $qty) {
            order {
                id
                subTotal
                subTotalWithTax
                total
                totalWithTax
                totalQuantity
            }
            errorMessage
        }
    }
`;

export const REMOVE_ITEM_FROM_CART = gql`
    mutation RemoveItemFromCart($id: ID!) {
        adjustOrderLineQuantity(orderLineId: $id, quantity: 0) {
            order {
                id
            }
            errorMessage
        }
    }
`;

export const ADD_MULTIPLE_ITEMS_TO_ORDER = gql`
    mutation AddMultipleItemsToOrder(
        $items: [BulkAddItemInput!]!
        $consolidatedFeedImport: Boolean
    ) {
        addMultipleItemsToOrder(
            items: $items
            consolidatedFeedImport: $consolidatedFeedImport
        ) {
            order {
                id
                lines {
                    id
                    quantity
                    productVariant {
                        id
                        name
                    }
                }
            }
            failedProductGtins
            stockShortfalls { gtin requestedQuantity importedQuantity missingQuantity }
            moqViolations {
                gtin
                moq
                quantity
            }
        }
    }
`;

export const REMOVE_ALL_ITEMS = gql`
    mutation RemoveAllItemsFromOrder {
        removeAllItemsFromOrder
    }
`;
